export default function getAspectUrl(aspect, domain) {
    const domainWithProtocol = `https://${domain}/`;
    const aspectURL = new URL(aspect.url, domainWithProtocol);
    return aspectURL.href;
}

export {
    getAspectUrl,
};
